/* eslint-disable react-hooks/exhaustive-deps */
import { SearchOutlined } from '@ant-design/icons';
import { Button, Form, Input, Select, Table, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ModalExport from './ModalExport';
import CustomizeBannerService from '../../../services/CustomizeBanner.service';
import CookieManagementService from '../../../services/CookieManagement.service';
import usePermission from '../../../hooks/usePermission';

const { Option } = Select;

export default function ConsentLog({
    form,
    companyId,
    domainId,
    period,
    yearList,
    refresh,
    setRefresh,
    year,
}) {
    const { t, i18n } = useTranslation();
    const [openModal, setOpenModal] = useState(false);
    const [actionList, setActionList] = useState([]);
    const [cookieCategoryList, setCookieCategoryList] = useState([]);
    // const [loading, setLoading] = useState(true);
    const [cookieCategoryId, setCookieCategoryId] = useState();
    const [ipAddress, setIpAddress] = useState();
    const [actionId, setActionId] = useState();
    const [cookieConsentLog, setCookieConsentLog] = useState([]);
    const [currentPage, setCurrentPage] = useState({
        p: 1,
        ps: 10,
        s: 'actionDate',
        sd: 'DESC',
        total: 0,
    });

    // Loading
    const [isLoading, setIsLoading] = useState(false);

    let lang = i18n.language;

    const columns = [
        {
            title: t('COOKIE.ActionDate'),
            dataIndex: 'actionDate',
            key: 'actionDate',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Domain'),
            dataIndex: 'domain',
            key: 'domain',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Action'),
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            sorter: true,
            render: (value, row, index) => {
                return _getTagAction(value);
            },
        },
        {
            title: t('COOKIE.CookieCategory'),
            dataIndex: 'cookieCategory',
            key: 'cookieCategory',
            align: 'center',
            sorter: true,
            render: (value, row, index) => {
                return _getCookieCategory(row);
            },
        },
        {
            title: t('COOKIE.IPAddress'),
            dataIndex: 'ipAddress',
            key: 'ipAddress',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('COOKIE.SessionId'),
            dataIndex: 'sessionId',
            key: 'sessionId',
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
        {
            title: t('Version'),
            dataIndex: 'version',
            key: 'version',
            sorter: true,
            render: (value, row, index) => {
                return <>{value ? <div>{value}</div> : <>-</>}</>;
            },
        },
    ];

    const _getTagAction = (e) => {
        if (e === 'Dismiss') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#65707A', borderColor: '#65707A' }}
                >
                    {t('COOKIE.tDismiss')}
                </Tag>
            );
        } else if (e === 'Informed') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F9C153', borderColor: '#F9C153' }}
                >
                    {t('COOKIE.tInformed')}
                </Tag>
            );
        } else if (e === 'Accepted') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                >
                    {t('COOKIE.tAccepted')}
                </Tag>
            );
        } else if (e === 'Rejected') {
            return (
                <Tag
                    className="rounded-xl -my-1 text-center"
                    style={{ color: '#F0536F', borderColor: '#F0536F' }}
                >
                    {t('COOKIE.tRejected')}
                </Tag>
            );
        } else {
            return <>-</>;
        }
    };

    const _getCookieCategory = (e) => {
        switch (e?.cookieCategoryEn) {
            case 'Necessary':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        color="#44B6A5"
                    >
                        {/* {t('COOKIE.Necessary')} */}
                        {lang === 'en'
                            ? e?.cookieCategoryEn
                            : e?.cookieCategoryTh}
                    </Tag>
                );
            case 'Analytics':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        color="#61DDAA"
                    >
                        {/* {t('COOKIE.Analytics')} */}
                        {lang === 'en'
                            ? e?.cookieCategoryEn
                            : e?.cookieCategoryTh}
                    </Tag>
                );
            case 'Marketing':
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        color="#9CE2DD"
                    >
                        {/* {t('COOKIE.Marketing')} */}
                        {lang === 'en'
                            ? e?.cookieCategoryEn
                            : e?.cookieCategoryTh}
                    </Tag>
                );
            default:
                return (
                    <Tag
                        className="rounded-xl -my-1 text-center px-4 text-white"
                        color="#BAC2F2"
                    >
                        {lang === 'en'
                            ? e?.cookieCategoryEn
                            : e?.cookieCategoryTh}
                    </Tag>
                );
        }
    };

    const onChange = (e) => {
        setIpAddress(e.target.value);
    };
    const onCategoryChange = async (value) => {
        setCookieCategoryId(value);
    };
    const onActionChange = async (value) => {
        setActionId(value);
    };

    useEffect(() => {
        const getAction = async () => {
            try {
                const { data } = await CustomizeBannerService.getAction();
                if (data?.resultData) {
                    setActionList(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };

        getAction();
    }, []);

    useEffect(() => {
        const getCategory = async () => {
            let ObjectSearch = {};
            ObjectSearch = {
                companyId: companyId,
                domainId: domainId,
            };
            try {
                const { data } =
                    await CookieManagementService.getCookieCategoryList(
                        ObjectSearch
                    );
                if (data?.resultData) {
                    const item = data?.resultData;
                    const allItem = item?.general.concat(item?.unclassify);
                    const result = Object.values(
                        allItem.reduce(
                            (acc, obj) => ({
                                ...acc,
                                [obj.categoryNameEn]: obj,
                            }),
                            {}
                        )
                    );
                    await setCookieCategoryList(result);
                }
            } catch (error) {
                console.log(error);
            }
        };

        if (companyId) {
            getCategory();
        }
    }, [companyId, domainId]);

    const getCookieConsentLog = async (pageValue) => {
        let ObjectSearch = {};
        ObjectSearch = {
            //Last 7 Days, Last 30 Days, This Month, Last Month, This Year
            period: period,
            domainId: domainId,
            companyId: companyId,
            keyword: ipAddress || null,
            action: actionId || null,
            cookieCategoryEn: cookieCategoryId || null,
            p: pageValue.p,
            ps: pageValue.ps,
            s: pageValue.s,
            sd: pageValue.sd,
        };
        if (period === 'Yearly') {
            ObjectSearch.year = year;
        }
        // setRefresh(false);
        setIsLoading(true);
        try {
            const { data } = await CustomizeBannerService.getCookieConsentLog(
                ObjectSearch
            );
            if (data?.resultData) {
                const item = [];
                data?.resultData?.result?.forEach((element) => {
                    item.push({
                        ...element,
                        id:
                            Math.random().toString(26).slice(2) +
                            element?.sessionId,
                    });
                });
                await setCookieConsentLog(item || []);
                setCurrentPage({
                    p: data?.resultData?.page,
                    ps: data?.resultData?.pageSize,
                    total: data?.resultData?.total,
                });
                setRefresh(false);
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (refresh === true) {
            if (companyId && period) {
                form.resetFields(['ipAddress', 'actionId', 'cookieCategoryId']);
                setIpAddress('');
                setActionId('');
                setCookieCategoryId('');
                getCookieConsentLog({
                    p: 1,
                    ps: 10,
                    s: 'actionDate',
                    sd: 'desc',
                    total: 0,
                });
            }
        } else {
            if (companyId && period) {
                getCookieConsentLog({
                    p: 1,
                    ps: 10,
                    s: 'actionDate',
                    sd: 'desc',
                    total: 0,
                });
            }
        }
    }, [
        companyId,
        domainId,
        period,
        ipAddress,
        actionId,
        cookieCategoryId,
        refresh,
        year,
    ]);

    const getExport = async () => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId,
            domainId,
            period,
            keyword: ipAddress,
            action: actionId,
            cookieCategoryEn: cookieCategoryId,
        };

        try {
            const res = await CustomizeBannerService.getExport(ObjectSearch);
            const data = res?.data;
            if (data) {
                const blob = new Blob([data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveBlob(
                        blob,
                        'cookie-scanner-report.csv'
                    );
                } else {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.setAttribute('download', 'cookie-scanner-report.csv');
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        } catch (error) {
            console.log(error);
        }
    };

    const onPageChange = async (pagination, filters, sorter) => {
        const pageValues = {
            p: pagination.current,
            ps: pagination.pageSize,
            s: sorter && sorter.order ? sorter.columnKey : 'actionDate',
            sd:
                sorter && sorter.order
                    ? sorter.order.substring(0, 3).toUpperCase() === 'ASC'
                        ? 'asc'
                        : 'desc'
                    : 'desc',
            total: currentPage.total,
        };
        setCurrentPage(pageValues);
        getCookieConsentLog(pageValues);
    };

    const paginationProps = {
        current: parseInt(currentPage.p),
        // pageSize: 10,
        total: parseInt(currentPage.total),
        // showQuickJumper: true,
        showSizeChanger: true,
        showTotal: (total, range) => ` ${range[0]}-${range[1]} of ${total} `,
    };

    const { isAuditor, isUser } = usePermission();

    return (
        <>
            <div className="col-span-4 font-semibold text-xl">
                {t('COOKIE.CookieConsentLog')}
            </div>
            <div className="col-span-3">
                <Form.Item className="w-full mb-0'" name="ipAddress">
                    <Input
                        prefix={
                            <SearchOutlined className="site-form-item-icon" />
                        }
                        placeholder={t('COOKIE.SearchIPAddressSessionID')}
                        size="large"
                        onChange={onChange}
                    />
                </Form.Item>
            </div>
            <div className="col-span-2 ml-2">
                <Form.Item name="actionId" className="w-full mb-0">
                    <Select
                        size="large"
                        defaultValue=""
                        onChange={onActionChange}
                    >
                        <Option key={'All action'} value={''}>
                            {t('COOKIE.AllAction')}
                        </Option>
                        {actionList?.map((e) => (
                            <Option key={e.nameEn} value={e.nameEn}>
                                {lang === 'en' ? e.nameEn : e.nameTh}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>
            <div className="col-span-2 ml-2">
                <Form.Item name="cookieCategoryId" className="w-full mb-0">
                    <Select
                        size="large"
                        defaultValue=""
                        onChange={onCategoryChange}
                    >
                        <Option key={'All Cookie Category'} value={''}>
                            {t('COOKIE.AllCookieCategory')}
                        </Option>
                        {cookieCategoryList?.map((e) => (
                            <Option
                                key={e?.categoryNameEn}
                                value={e?.categoryNameEn}
                            >
                                {lang === 'en'
                                    ? e.categoryNameEn
                                    : e.categoryNameTh}
                            </Option>
                        ))}
                    </Select>
                </Form.Item>
            </div>
            <div className="col-span-1 ml-2">
                <Button
                    disabled={isAuditor || isUser}
                    onClick={() => {
                        if (period === 'Yearly') {
                            setOpenModal(true);
                        } else {
                            getExport();
                        }
                    }}
                    size="large"
                    type="primary"
                    className="px-9"
                >
                    {t('common.Export')}
                </Button>
            </div>

            <div className="col-span-12 mt-6">
                <Table
                    loading={isLoading}
                    onChange={onPageChange}
                    rowKey={(record) => record.id}
                    className="inbox_table"
                    dataSource={cookieConsentLog}
                    columns={columns}
                    pagination={paginationProps}
                />
            </div>
            <ModalExport
                detail={{
                    companyId,
                    domainId,
                    period,
                    ipAddress,
                    actionId,
                    cookieCategoryId,
                    yearList,
                }}
                open={openModal}
                handelClose={() => setOpenModal(false)}
            />
        </>
    );
}
